import { useState } from "react";

import { formatDateForPanelDisplay } from "../../../Utils/helper";
import BirthdayIcon from "../../../assets/images/birthdayicon.svg";
import DOIIcon from "../../../assets/images/incident.svg";
import DefendantServicePopup from "../../LitigationDashboard/Modals/DefendantServicePopup";

import "../LitigationCentral.css";
import useViewportTableRows from "./useViewportTableRows";

const DefendantsUnservedTab = ({ defendants = [], fetchLitigationActs }) => {
  const [showServicePopup, setShowServicePopup] = useState(false);
  const [selectedDefendant, setSelectedDefendant] = useState(null);

  const openServicePopup = (defendant) => {
    setShowServicePopup(true);
    setSelectedDefendant(defendant);
  };

  const { fakeRowCount, tableBodyRef, tableContainerRef } = useViewportTableRows(defendants.length);

  return (
    <div className="d-flex flex-column p-0">
      <div
        className="position-relative"
        style={{
          display: "flex",
          flexDirection: "column",
          scrollbarWidth: "none",
        }}
      >
        <div ref={tableContainerRef} className="table-responsive">
          <table className="table table-borderless table-striped table-treatment has-height-25 litigation-central-table">
            <thead>
              <tr id="tb-header">
                <th style={{ width: "25px", minWidth: "25px", maxWidth: "25px" }} />
                <th style={{ width: "20px" }} />
                <th className="td-autosize">Client</th>
                <th />
                <th className="td-autosize">Case</th>
                <th />
                <th className="td-autosize">Defendant</th>
                <th />
                <th className="text-center">Last Attempt</th>
                {/* <th />
                <th className="td-autosize">Served</th>
                <th />
                <th className="td-autosize">Proof</th> */}
              </tr>
            </thead>
            <tbody ref={tableBodyRef} className="invisible-scrollbar">
              {defendants.map((defendant, index) => (
                <tr
                  key={defendant?.id}
                  className="fw-semibold cursor-pointer"
                  onClick={() => openServicePopup(defendant)}
                >
                  <td
                    style={{
                      color: "var(--primary-25)",
                      alignContent: "start",
                    }}
                  >
                    {index + 1}
                  </td>
                  <td />
                  <td>
                    <div className="d-flex align-items-center">
                      <div
                        className="icon-container"
                        style={{
                          display: "flex",
                          height: "19px",
                          width: "19px",
                          marginRight: "4px",
                        }}
                      >
                        {defendant?.for_case?.for_client?.profile_pic_29p ? (
                          <img
                            className="client_profile_image_63"
                            src={defendant?.for_case?.for_client?.profile_pic_29p}
                            alt="John Doe"
                          />
                        ) : (
                          <i className="ic ic-client-avatar h-100 w-100" />
                        )}
                        {/* <div className="border-overlay" /> */}
                      </div>
                      <div>
                        {defendant?.for_case?.for_client?.first_name +
                          " " +
                          defendant?.for_case?.for_client?.last_name}
                      </div>
                    </div>
                    <div className="d-flex align-items-center">
                      <img
                        style={{ height: "15px", width: "15px", marginRight: "5px" }}
                        src={BirthdayIcon}
                        alt={"birthday"}
                      />
                      {defendant?.for_case?.for_client?.birthday}
                    </div>
                    <div className="d-flex align-items-center">
                      <img
                        style={{ height: "15px", width: "15px", marginRight: "5px" }}
                        src={defendant?.for_case?.case_type?.casetype_icon}
                        alt={"car accident"}
                      />
                      {defendant?.for_case?.case_type?.name}
                    </div>
                    <div className="d-flex align-items-center">
                      <img
                        style={{ height: "15px", width: "15px", marginRight: "5px" }}
                        src={DOIIcon}
                        alt={"incident"}
                      />
                      {formatDateForPanelDisplay(defendant?.for_case?.incident_date)}
                    </div>
                  </td>
                  <td />
                  {/* ----------------Litigation Case Name Cell */}
                  <td className="text-center">
                    <div>{defendant?.litigation?.case_short_name}</div>
                    <div>{defendant?.litigation?.case_number}</div>
                  </td>
                  <td />
                  <td className="td-autosize text-start height-21">
                    <i className="ic ic-15 ic-defendants m-r-5 m-l-5" />
                    {defendant?.defendantType?.id === 1
                      ? `${defendant?.first_name || ""} ${defendant?.last_name || ""}`.trim()
                      : defendant?.entity_name || ""}
                  </td>
                  <td />
                  <td
                    className="text-center height-21 text-capitalize"
                    style={{
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      maxWidth: 0,
                    }}
                  >
                    {defendant?.attempt_dates?.length
                      ? `${defendant.attempt_dates.at(-1).service_type} Service: `
                      : ""}
                    {defendant?.attempt_dates?.length
                      ? formatDateForPanelDisplay(defendant.attempt_dates.at(-1).date)
                      : ""}
                  </td>
                  {/* <td />
                  <td className="text-end height-21">
                    {formatDateForPanelDisplay(defendant?.defServedDate)}
                  </td>
                  <td />
                  <td onClick={(event) => handleProofClick(event, defendant)}>
                    <span className="ic ic-19">
                      <img
                        src={defendant?.proof_of_service ? YesDocIcon : NoDocIcon}
                        alt="Doc"
                        width="19"
                        height="19"
                        className="cursor-pointer"
                        loading="lazy"
                      />
                    </span>
                  </td> */}
                </tr>
              ))}
              {[...Array(fakeRowCount)].map((_, index) => (
                <tr
                  key={`additional-${index}`}
                  className="fake-row-2 height-21"
                  style={{ height: "21px" }}
                >
                  <td className="height-21" colSpan="10">
                    &nbsp;
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {showServicePopup && (
        <DefendantServicePopup
          showPopup={showServicePopup}
          handleClose={() => setShowServicePopup(false)}
          handleRefresh={fetchLitigationActs}
          initialSelectedDefendantId={selectedDefendant?.id}
          selectedDefendantObj={selectedDefendant}
          central={true}
        />
      )}
    </div>
  );
};

export default DefendantsUnservedTab;
